import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  officialResourceCategories,
  officialResources,
} from '../data/officialResources';
import { adjacentRefs } from '../data/adjacentRefs';
import { AnalyticsEvents, trackEvent } from '../utils/analytics';
import { usePageMeta } from '../hooks/usePageMeta';
import '../styles/Resources.css';

const Resources = () => {
  const [category, setCategory] = useState('all');

  usePageMeta({
    title: '공식 자료',
    description:
      'JASSO·대사관·DNC 등 일본 학부 입시 공식·공신력 링크만 모았습니다. 학원 블로그 제외.',
    path: '/resources',
  });

  const rows = useMemo(() => {
    if (category === 'all') return officialResources;
    return officialResources.filter((r) => r.category === category);
  }, [category]);

  return (
    <div className="apple-page apple-resources">
      <header className="apple-page-hero">
        <p className="apple-eyebrow">Official links</p>
        <h1 className="apple-display">공식 자료</h1>
        <p className="apple-lede">
          수험생이 바로 열어볼 수 있는 공식·공신력 출처만 모았습니다. 학원·개인 블로그는 넣지 않았습니다.
          일정·요강은 항상 원문 기준으로 확인하세요.
        </p>
      </header>

      <div className="apple-resource-filters" role="tablist" aria-label="자료 분류">
        {officialResourceCategories.map((cat) => (
          <button
            key={cat.id}
            type="button"
            role="tab"
            aria-selected={category === cat.id}
            className={category === cat.id ? 'is-on' : ''}
            onClick={() => setCategory(cat.id)}
          >
            {cat.label}
          </button>
        ))}
      </div>

      <div className="apple-resource-table-wrap">
        <table className="apple-resource-table">
          <thead>
            <tr>
              <th scope="col">자료</th>
              <th scope="col">기관</th>
              <th scope="col">왜 보나</th>
              <th scope="col">언어</th>
              <th scope="col">링크</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td data-label="자료">{row.name}</td>
                <td data-label="기관">{row.org}</td>
                <td data-label="왜 보나">{row.why}</td>
                <td data-label="언어">{row.lang}</td>
                <td data-label="링크">
                  <a
                    href={row.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      trackEvent(AnalyticsEvents.RESOURCE_OUTBOUND, {
                        id: row.id,
                        org: row.org,
                      })
                    }
                  >
                    열기
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="apple-resource-note">
        링크는 안내 목적입니다. 모집·시험 일정은 해당 기관 최신 공고를 따릅니다.
      </p>

      <section className="apple-resource-adjacent" aria-label="참고">
        <h2 className="apple-resource-adjacent-title">참고 (비공식)</h2>
        {adjacentRefs.length === 0 ? (
          <p className="apple-resource-note">
            지금은 제휴·비공식 링크를 두지 않습니다. 위 공식 자료 표를 우선 확인하세요.
          </p>
        ) : (
          <ul className="apple-resource-adjacent-list">
            {adjacentRefs.map((ref) => (
              <li key={ref.id}>
                <a href={ref.url} target="_blank" rel="noopener noreferrer">
                  {ref.label}
                </a>
                <span> — {ref.why}</span>
                {ref.note && <p className="apple-resource-note">{ref.note}</p>}
              </li>
            ))}
          </ul>
        )}
      </section>

      <div className="apple-page-foot">
        <Link to="/universities" className="apple-btn apple-btn-primary">대학 입시 안내</Link>
        <Link to="/finder" className="apple-link">루트 찾기</Link>
        <Link to="/guides" className="apple-link">가이드</Link>
      </div>
    </div>
  );
};

export default Resources;
